import { createSlice } from "@reduxjs/toolkit";
import apiSlice from "./apiSlice";
import type { User } from "../types";

interface LoginState {
    isLoggedIn: boolean;
    user: User | null;
    accessToken: string | null;
    refreshToken: string | null;
}

function getInitialLoginState(): LoginState {
    const accessToken = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");
    return {
        isLoggedIn: !!accessToken,
        user: null,
        accessToken: accessToken ?? null,
        refreshToken: refreshToken ?? null,
    };
}

const initialState: LoginState = getInitialLoginState();

const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        setAccessToken: (state, action) => {
            state.accessToken = action.payload;
        },
        setRefreshToken: (state, action) => {
            state.refreshToken = action.payload;
        },
        setIsLoggedIn: (state, action) => {
            state.isLoggedIn = action.payload;
        },
        clearLogin: (state) => {
            state.accessToken = null;
            state.refreshToken = null;
            state.isLoggedIn = false;
            state.user = null;
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(apiSlice.endpoints.verifyLogin.matchFulfilled,
            (state, {payload}) => {
                state.accessToken = payload.access;
                localStorage.setItem("access_token", payload.access);
                state.refreshToken = payload.refresh;
                localStorage.setItem("refresh_token", payload.refresh);
                state.isLoggedIn = true;
                state.user = payload.user;
            }
        ),
        builder.addMatcher(apiSlice.endpoints.verifyEmailLogin.matchFulfilled,
            (state, {payload}) => {
                state.accessToken = payload.access;
                localStorage.setItem("access_token", payload.access);
                state.refreshToken = payload.refresh;
                localStorage.setItem("refresh_token", payload.refresh);
                state.isLoggedIn = true;
                state.user = payload.user;
            }
        ),
        builder.addMatcher(apiSlice.endpoints.getUser.matchFulfilled,
            (state, {payload}) => {
                state.user = payload;
            }
        )
    },
});

export const { setAccessToken, setRefreshToken, setIsLoggedIn, clearLogin } = loginSlice.actions;
export default loginSlice.reducer;